import script from "./DraftCollectionsAnnotation.vue?vue&type=script&setup=true&lang=js"
export * from "./DraftCollectionsAnnotation.vue?vue&type=script&setup=true&lang=js"

import "./DraftCollectionsAnnotation.vue?vue&type=style&index=0&id=35030f83&lang=scss&scoped=true"
script.__scopeId = "data-v-35030f83"

export default script